<template>
  <div class="howto" @click="$emit('showCards')">
    <!-- <div class="white--text text-center size-18 mb-2">
      0/{{cards.length}}
    </div> -->
    <v-card class="howto-card mx-auto mb-5">
      <div class="find-text">
        Welches E-Auto gefällt dir?
      </div>
      <div class="swipe-right text-center">
        <img src="@/assets/img/swipe_right.png" width="70" />
        <div class="swipe-text">
          Gefällt mir
        </div>
      </div>
      <div class="swipe-left text-center">
        <img src="@/assets/img/swipe_left.png" width="70" />
        <div class="swipe-text">
          Gefällt mir nicht
        </div>
      </div>
      <div class="text-center">
        <v-btn class="swipe-btn" @click.stop="$emit('showCards')" rounded>
          OK
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import vehicles from '@/api/vehicles.json'

export default {
  name: 'howto-swipe',
  data: () => ({
    cards: vehicles
  })
}
</script>

<style lang="scss" scoped>
.howto {
  background-image: url('~@/assets/img/background3.png');
  background-size: cover;
  height: 100%;
  padding-top: 110px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: center;
}
@media only screen and (max-width: 499px) {
  .howto {
    height: 100vh;
  }
}
.howto-card {
  width: 90%;
  border-radius: 15px !important;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-height: 610px;
  justify-content: space-evenly;

  .find-text {
    height: 65px;

    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    text-align: center;

    color: #020B2D;
  }

  .swipe-left {
    height: 120px;
  }
  .swipe-right {
    height: 120px;
  }
  .swipe-text {
    height: 33px;

    font-size: 18px;
    line-height: 22px;
    text-align: center;

    color: #020B2D;
  }
  .swipe-btn {
    width: 182px;
    height: 50px;
    // margin-top: auto;
    color: white;
    background: linear-gradient(15.36deg, #021325 0%, #2F5678 100%);
    box-shadow: 0px 2px 4px rgba(80, 80, 80, 0.12);
    border-radius: 25px;
  }
}
</style>